<template>
  <div class="privacy-policy-page">
    <LegalPageHero title="Privacy Policy" />
    <LegalDocumentContent>
      <p class="legal-intro">
        This Privacy Policy outlines the types of information that Eddy and
        edm8ker Inc. ("we," "us," "our") may collect from you when you visit our
        website, how we use that information, and the choices you have regarding
        our use of your personal data. By using our website, you agree to this
        Privacy Policy.
      </p>

      <section class="legal-section">
        <h2 class="legal-section__title">1. Information We Collect</h2>
        <div class="legal-section__body">
          <p>
            We may collect various types of personal data from you, including:
          </p>
          <ul>
            <li>
              Contact information, such as your name, email address, phone
              number, and mailing address.
            </li>
            <li>
              Demographic information, such as your age, gender, and location.
            </li>
            <li>
              Information about your use of our website, such as your IP
              address, browser type, and operating system.
            </li>
            <li>Any other information you choose to provide to us.</li>
          </ul>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">2. How We Use Your Information</h2>
        <div class="legal-section__body">
          <p>We may use your personal data for the following purposes:</p>
          <ul>
            <li>
              To provide you with the products or services you have requested.
            </li>
            <li>To personalize your experience on our website.</li>
            <li>To improve our website and the services we offer.</li>
            <li>
              To communicate with you about our products, services, and
              promotions.
            </li>
            <li>To conduct research and analytics.</li>
            <li>To comply with legal obligations.</li>
          </ul>
        </div>
      </section>
    </LegalDocumentContent>
  </div>
</template>

<script setup>
import LegalPageHero from "@/components/legal/LegalPageHero.vue";
import LegalDocumentContent from "@/components/legal/LegalDocumentContent.vue";
</script>

<style scoped>
.privacy-policy-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: var(--white);
}

@media (max-width: 768px) {
  .privacy-policy-page {
    gap: 0;
  }
}
</style>
